import {
    defaultUserSorting,
    USER_SORTING_SELECT
} from '../constants/users';

export default function userSorting(state = defaultUserSorting, action) {
    if (action.type === USER_SORTING_SELECT) {
        let sorting = action.sorting;

        return sorting;
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/userSorting.js